import { Grid } from '@mui/material'
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getAgrochemicalsPerGroup,
    getCapitalGoodsAndServicesPerGroup,
    getCarHirePerGroup,
    getChemicalsAndAdditivesPerGroup,
    getDownstreamDistributionPerGroup,
    getFlightsAndAccommodationPerGroup,
    getOtherPerGroup,
    getPackagingPerGroup,
    getPetrolCardsPerGroup,
    getWasteGeneratedPerGroup,
    getWaterPerGroup,
    getWineAndGrapesPerGroup,
    getWoodenProductsPerGroup
} from '../../../../../../../actions/carbonfootprint-rework/06-dashboard/01-dashboard';
import { DataAccordion } from '../../../../../../shared-components/DataAccordion';
import MainCategoryButtons from '../../../shared-components/MainCategoryButtons';
import SubCategoryButtons from '../../../shared-components/SubCategoryButtons';
import GraphMainHeader from '../../../shared-components/GraphMainHeader';
import GraphSubHeader from '../../../shared-components/GraphSubHeader';
import GraphPairForGroups from '../../../shared-components/GraphPairForGroups';
import GroupStackedBarGraph from '../../../shared-components/GroupStackedBarGraph';
import AgrochemicalsGraphPairForGroups from '../../../shared-components/AgrochemicalsGraphPairForGroups';


export const ScopeThreeConsumptionOverview = ({ openAccordion, changeAccordion, company, title, year, companyName, groupArray }) => {
    const dispatch = useDispatch()
    const [mainCategory, setMainCategory] = useState('Waste Generated in Operations');
    const [subCategory, setSubCategory] = useState(null)

    const scopeThreeOverviewCategories = ['Waste Generated in Operations', 'Business Travel', 'Distribution', 'Purchased Goods and Services']
    const purchasedGoodsAndServicesCategories = ['Water', 'Chemicals and Additives', 'Wooden Products', 'Packaging', 'Wine and Grapes', 'Other', 'Capital Goods']
    const accordionName = 'Scope Three Consumption Overview'

    // Waste Generated Graphs
    const wasteToLandfillPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.wasteToLandfillPerGroup?.data?.graph)
    const wasteToLandfillPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.wasteToLandfillPerGroup?.data?.pie)
    const wasteToRecyclingPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.wasteToRecyclingPerGroup?.data?.graph)
    const wasteToRecyclingPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.wasteToRecyclingPerGroup?.data?.pie)
    const wasteToCompostingPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.wasteToCompostingPerGroup?.data?.graph)
    const wasteToCompostingPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.wasteToCompostingPerGroup?.data?.pie)
    const wastewaterTreatmentPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.wastewaterTreatmentPerGroup?.data?.graph)
    const wastewaterTreatmentPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.wastewaterTreatmentPerGroup?.data?.pie)
    const wasteToBiocharProductionPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.wasteToBiocharProductionPerGroup?.data?.graph)
    const wasteToBiocharProductionPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.wasteToBiocharProductionPerGroup?.data?.pie)
    // Business Travel Graphs
    // -- Flights and Accommodation
    const flightsAndAccommodationPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.flightsAndAccommodationPerGroup?.data?.graph)
    const flightsAndAccommodationPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.flightsAndAccommodationPerGroup?.data?.pie)
    // -- Car Hire
    const carHireDieselPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.carHireDieselPerGroup?.data?.graph)
    const carHireDieselPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.carHireDieselPerGroup?.data?.pie)
    const carHirePetrolPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.carHirePetrolPerGroup?.data?.graph)
    const carHirePetrolPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.carHirePetrolPerGroup?.data?.pie)
    // -- Petrol Cards
    const petrolCardsDieselPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.petrolCardsDieselPerGroup?.data?.graph)
    const petrolCardsDieselPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.petrolCardsDieselPerGroup?.data?.pie)
    const petrolCardsPetrolPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.petrolCardsPetrolPerGroup?.data?.graph)
    const petrolCardsPetrolPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.petrolCardsPetrolPerGroup?.data?.pie)
    // Downstream Distribution
    const interDcDistributionPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.interDcDistributionPerGroup?.data?.graph)
    const interDcDistributionPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.interDcDistributionPerGroup?.data?.pie)
    const farmDcDistributionPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.farmDcDistributionPerGroup?.data?.graph)
    const farmDcDistributionPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.farmDcDistributionPerGroup?.data?.pie)
    const shippingDistributionPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.shippingDistributionPerGroup?.data?.graph)
    const shippingDistributionPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.shippingDistributionPerGroup?.data?.pie)
    const regionalDistributionPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.regionalDistributionPerGroup?.data?.graph)
    const regionalDistributionPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.regionalDistributionPerGroup?.data?.pie)
    // Purchased Goods and Services
    // Water
    const waterPerGroupGraph = useSelector((state) => state.carbonFootprintDashboardReducer.waterPerGroup?.data?.graph)
    const waterPerGroupPie = useSelector((state) => state.carbonFootprintDashboardReducer.waterPerGroup?.data?.pie)
    // Chemicals and Additives
    const chemicalsAndAdditivesPerGroupData = useSelector((state) => state.carbonFootprintDashboardReducer.chemicalsAndAdditivesPerGroup?.data)
    const agrochemicalsPerGroupGraph = useSelector((state) => (state.carbonFootprintDashboardReducer.agrochemicalsPerGroup?.data?.graph))
    const agrochemicalsPerGroupPie = useSelector((state) => (state.carbonFootprintDashboardReducer.agrochemicalsPerGroup?.data?.pie))
    // Wooden Products
    const woodenProductsPerGroupData = useSelector((state) => state.carbonFootprintDashboardReducer.woodenProductsPerGroup?.data)
    // Packaging
    const packagingPerGroupData = useSelector((state) => state.carbonFootprintDashboardReducer.packagingPerGroup?.data)
    // Wine and Grapes
    const wineAndGrapesLiquidsPerGroupData = useSelector((state) => state.carbonFootprintDashboardReducer.wineAndGrapesPerGroup?.data?.liquids)
    const wineAndGrapesSolidsPerGroupData = useSelector((state) => state.carbonFootprintDashboardReducer.wineAndGrapesPerGroup?.data?.solids)
    // Other
    const otherPerGroupData = useSelector((state) => state.carbonFootprintDashboardReducer.otherPerGroup?.data)
    // Capital Goods and Services
    const capitalGoodsAndServicesGroupData = useSelector((state) => (state.carbonFootprintDashboardReducer.capitalGoodsAndServicesPerGroup?.data))

    useEffect(() => {
        if (openAccordion === accordionName && company && year) {
            // when mainCategory changes, we should be sure to set subCategory to null, if its
            // not already null. This could cause bugs to happen
            if (mainCategory !== 'Purchased Goods and Services' && subCategory) {
                setSubCategory(null)
            }
            else if (mainCategory === 'Waste Generated in Operations') {
                // Fetch waste generated data
                dispatch(getWasteGeneratedPerGroup(company, year, 'waste-to-landfill'))
                dispatch(getWasteGeneratedPerGroup(company, year, 'waste-to-recycling'))
                dispatch(getWasteGeneratedPerGroup(company, year, 'waste-to-composting'))
                dispatch(getWasteGeneratedPerGroup(company, year, 'wastewater-treatment'))
                dispatch(getWasteGeneratedPerGroup(company, year, 'waste-to-biochar-production'))
            }
            else if (mainCategory === 'Business Travel') {
                // Fetch business travel data
                dispatch(getFlightsAndAccommodationPerGroup(company, year))
                dispatch(getCarHirePerGroup(company, year, 'Diesel'))
                dispatch(getCarHirePerGroup(company, year, 'Petrol'))
                dispatch(getPetrolCardsPerGroup(company, year, 'Diesel'))
                dispatch(getPetrolCardsPerGroup(company, year, 'Petrol'))
            }
            else if (mainCategory === 'Employee Commuting') {
                // Fetch employee commuting data
            }
            else if (mainCategory === 'Purchased Goods and Services') {
                if (subCategory === null) {
                    setSubCategory('Water')
                }
                // fetch purchased goods and services data
                else if (subCategory === 'Water') {
                    dispatch(getWaterPerGroup(company, year))
                }
                else if (subCategory === 'Chemicals and Additives') {
                    dispatch(getChemicalsAndAdditivesPerGroup(company, year))
                    dispatch(getAgrochemicalsPerGroup(company, year))
                }
                else if (subCategory === 'Wooden Products') {
                    dispatch(getWoodenProductsPerGroup(company, year))
                }
                else if (subCategory === 'Packaging') {
                    dispatch(getPackagingPerGroup(company, year))
                }
                else if (subCategory === 'Wine and Grapes') {
                    dispatch(getWineAndGrapesPerGroup(company, year))
                }
                else if (subCategory === 'Other') {
                    dispatch(getOtherPerGroup(company, year))
                }
                else if (subCategory === 'Capital Goods') {
                    dispatch(getCapitalGoodsAndServicesPerGroup(company, year))
                }
            }
            else if (mainCategory === 'Distribution') {
                // fetch distribution data
                dispatch(getDownstreamDistributionPerGroup(company, year, 'Inter-DC Distribution'))
                dispatch(getDownstreamDistributionPerGroup(company, year, 'Farm-DC Distribution'))
                dispatch(getDownstreamDistributionPerGroup(company, year, 'Shipping Distribution'))
                dispatch(getDownstreamDistributionPerGroup(company, year, 'Regional Distribution'))
            }
        }
    }, [dispatch, openAccordion, company, year, mainCategory, subCategory]);

    return (
        <DataAccordion
            title={title}
            show={openAccordion === accordionName}
            handleChange={() => changeAccordion(accordionName)}
        >
            <MainCategoryButtons mainCategories={scopeThreeOverviewCategories} selectedCategory={mainCategory} setSelectedCategory={setMainCategory} />

            <Grid container mb={'3rem'}>
                {mainCategory === 'Waste Generated in Operations' &&
                    <>
                        <GraphMainHeader>{mainCategory} {year}</GraphMainHeader>

                        <GraphSubHeader>Waste to Landfill</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={wasteToLandfillPerGroupGraph}
                            pieChartData={wasteToLandfillPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Waste to Landfill'}
                            unit={'Kilograms'}
                        />

                        <GraphSubHeader>Waste to Recycling</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={wasteToRecyclingPerGroupGraph}
                            pieChartData={wasteToRecyclingPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Waste to Recycling'}
                            unit={'Kilograms'}
                        />

                        <GraphSubHeader>Waste to Composting</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={wasteToCompostingPerGroupGraph}
                            pieChartData={wasteToCompostingPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Waste to Composting'}
                            unit={'Kilograms'}
                        />

                        <GraphSubHeader>Wastewater Treatment</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={wastewaterTreatmentPerGroupGraph}
                            pieChartData={wastewaterTreatmentPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Wastewater Treatment'}
                            unit={'Kilolitres'}
                        />

                        <GraphSubHeader>Waste to Biochar Production</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={wasteToBiocharProductionPerGroupGraph}
                            pieChartData={wasteToBiocharProductionPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Waste to Biochar Production'}
                            unit={'Kilograms'}
                        />


                    </>
                }
                {mainCategory === 'Business Travel' &&
                    <>
                        <GraphMainHeader>{mainCategory} {year}</GraphMainHeader>

                        <GraphSubHeader>Flights and Accommodation</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={flightsAndAccommodationPerGroupGraph}
                            pieChartData={flightsAndAccommodationPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Flights and Accommodation'}
                            unit={'kgCO2e'}
                        />
                        <GraphSubHeader>Car Hire</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={carHireDieselPerGroupGraph}
                            pieChartData={carHireDieselPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Car Hire (Diesel)'}
                            unit={'Kilometres'}
                        />
                        <GraphPairForGroups
                            barGraphData={carHirePetrolPerGroupGraph}
                            pieChartData={carHirePetrolPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Car Hire (Petrol)'}
                            unit={'Kilometres'}
                        />
                        <GraphSubHeader>Petrol Cards</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={petrolCardsDieselPerGroupGraph}
                            pieChartData={petrolCardsDieselPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Petrol Cards (Diesel)'}
                            unit={'Kilometres'}
                        />
                        <GraphPairForGroups
                            barGraphData={petrolCardsPetrolPerGroupGraph}
                            pieChartData={petrolCardsPetrolPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Petrol Cards (Petrol)'}
                            unit={'Kilometres'}
                        />

                    </>
                }
                {mainCategory === 'Distribution' &&
                    <>
                        <GraphMainHeader>{mainCategory} {year}</GraphMainHeader>

                        <GraphSubHeader>Inter-DC Distribution</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={interDcDistributionPerGroupGraph}
                            pieChartData={interDcDistributionPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Inter-DC Distribution'}
                            unit={'tonnes.km'}
                        />
                        <GraphSubHeader>Farm-DC Distribution</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={farmDcDistributionPerGroupGraph}
                            pieChartData={farmDcDistributionPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Farm-DC Distribution'}
                            unit={'tonnes.km'}
                        />
                        <GraphSubHeader>Shipping Distribution</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={shippingDistributionPerGroupGraph}
                            pieChartData={shippingDistributionPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Shipping Distribution'}
                            unit={'tonnes.km'}
                        />
                        <GraphSubHeader>Regional Distribution</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={regionalDistributionPerGroupGraph}
                            pieChartData={regionalDistributionPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Regional Distribution'}
                            unit={'tonnes.km'}
                        />
                    </>
                }
                {mainCategory === 'Purchased Goods and Services' &&
                    <>
                        <GraphMainHeader>{mainCategory} {year}</GraphMainHeader>
                        <SubCategoryButtons subCategories={purchasedGoodsAndServicesCategories} selectedSubCategory={subCategory} setSelectedSubCategory={setSubCategory} />
                        {subCategory === 'Water' &&
                            <>
                                <GraphSubHeader>Water</GraphSubHeader>
                                <GraphPairForGroups
                                    barGraphData={waterPerGroupGraph}
                                    pieChartData={waterPerGroupPie}
                                    year={year}
                                    companyName={companyName}
                                    groupArray={groupArray}
                                    type={'Purchased Water'}
                                    unit={'Kilolitres'}
                                />
                            </>
                        }
                        {subCategory === 'Chemicals and Additives' &&
                            <>
                                <GraphSubHeader>Chemicals and Additives</GraphSubHeader>
                                <GroupStackedBarGraph
                                    stackedBarGraphData={chemicalsAndAdditivesPerGroupData}
                                    year={year}
                                    companyName={companyName}
                                    groupArray={groupArray}
                                    type={'Purchased Chemicals and Additives'}
                                    unit={"Amount"}
                                />

                                <GraphSubHeader>Agrochemicals Applied</GraphSubHeader>
                                <AgrochemicalsGraphPairForGroups
                                    barGraphData={agrochemicalsPerGroupGraph}
                                    pieChartData={agrochemicalsPerGroupPie}
                                    year={year}
                                    groupArray={groupArray}
                                    companyName={companyName}
                                    type={'Agrochemicals Applied'}
                                    unit={'Kilograms'}
                                />
                            </>
                        }
                        {subCategory === 'Wooden Products' &&
                            <>
                                <GraphSubHeader>Wooden Products</GraphSubHeader>
                                <GroupStackedBarGraph
                                    stackedBarGraphData={woodenProductsPerGroupData}
                                    year={year}
                                    companyName={companyName}
                                    groupArray={groupArray}
                                    type={'Purchased Wooden Products'}
                                    unit={"Number of items"}
                                />
                            </>
                        }
                        {subCategory === 'Packaging' &&
                            <>
                                <GraphSubHeader>Packaging</GraphSubHeader>
                                <GroupStackedBarGraph
                                    stackedBarGraphData={packagingPerGroupData}
                                    year={year}
                                    companyName={companyName}
                                    groupArray={groupArray}
                                    type={'Purchased Packaging'}
                                    unit={"Kilograms"}
                                />
                            </>
                        }
                        {subCategory === 'Wine and Grapes' &&
                            <>
                                <GraphSubHeader>Bottled Wine and Bulk Wine</GraphSubHeader>
                                <GroupStackedBarGraph
                                    stackedBarGraphData={wineAndGrapesLiquidsPerGroupData}
                                    year={year}
                                    companyName={companyName}
                                    groupArray={groupArray}
                                    type={'Purchased Bottled Wine and Bulk Wine'}
                                    unit={"Kilolitres"}
                                />

                                <GraphSubHeader>Bulk Grapes</GraphSubHeader>
                                <GroupStackedBarGraph
                                    stackedBarGraphData={wineAndGrapesSolidsPerGroupData}
                                    year={year}
                                    companyName={companyName}
                                    groupArray={groupArray}
                                    type={'Purchased Bulk Grapes'}
                                    unit={"Kilograms"}
                                />
                            </>
                        }
                        {subCategory === 'Other' &&
                            <>
                                <GraphSubHeader>Other</GraphSubHeader>
                                <GroupStackedBarGraph
                                    stackedBarGraphData={otherPerGroupData}
                                    year={year}
                                    companyName={companyName}
                                    groupArray={groupArray}
                                    type={'Purchased Other'}
                                    unit={"Reams"}
                                />
                            </>
                        }
                        {subCategory === 'Capital Goods' &&
                            <>
                                <GraphSubHeader>Capital Goods and Services</GraphSubHeader>
                                <GroupStackedBarGraph
                                    stackedBarGraphData={capitalGoodsAndServicesGroupData}
                                    year={year}
                                    companyName={companyName}
                                    groupArray={groupArray}
                                    type={'Purchased Capital Goods and Services'}
                                    unit={'Rand'}
                                />
                            </>
                        }
                    </>
                }

            </Grid>
        </DataAccordion>
    )
}